export enum ScreensEnum {
    Home = 0,
    Role = 1,
    Screen = 2,
    ScreenRightGroup = 3,
    RoleToScreen = 4,
    User = 5,
    ProductFamily = 6,
    ProductLine = 7,
    AlgorithmGroups = 8,
    Algorithm = 9,
    NotificationRules = 10,
    NotificationTemplate = 11,
    TemplateLocale = 12,
    ServiceContract = 13,
    Exclusions = 14,
    MasterData = 15,
    Dashboard = 16,
    EnableDisable = 17,
    ServiceContractOverride = 18
}
